const isVideo = (url) => {
    return url.endsWith('.mp4');
};

export { isVideo as i };
